import React from 'react';

import Thumb from '../img/blogs/javascript-object-oriented-programming.jpg';

const JavaScriptObjectOrientedProgramming = {
    id: 8, permalink: "javascript-object-oriented-programming", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 02, 2020", categories: "JavaScript OOP", title: "JavaScript Object-Oriented Programming", shortDesc: "When a program is created with an object, it is called an object program. Styling the program of this object is called Object-Oriented Programming (OOP).", fullDesc: <>
        <h2>What is Object-Oriented Programming (OOP)?</h2>
        <p>When a <strong>program</strong> is created with an <strong>object</strong>, it is called an <strong>object program</strong>. Styling the program of this <strong>object</strong> is called <strong>Object-Oriented Programming (OOP)</strong>.</p>

        <p>There are three words in the word <strong>Object-Oriented Programming (OOP)</strong>. The first is <strong>Object</strong> which means an <strong>object or things</strong>. The second word is <strong>Oriented</strong>, <strong>Oriented</strong> is coming from <strong>Orient</strong>. And <strong>Orient</strong> means to face or surround something. That means <strong>Object-Oriented</strong> means surrounding the <strong>object</strong> or using the <strong>object</strong>. And so the <strong>programming</strong> that is done around an <strong>object</strong> or with a lot of <strong>objects</strong> is called <strong>Object-Oriented Programming (OOP)</strong>.</p>

        <p><em>There are three core concepts of <strong>Object-Oriented Programming (OOP)</strong></em>:</p>
        <ul>
            <li>Inheritance</li>
            <li>Polymorphism</li>
            <li>Encapsulation</li>
        </ul>


        <h2>Inheritance</h2>
        <p>It is the idea that some property and methods of an <strong>object</strong> are being used by another <strong>object</strong>. The <strong>object</strong> is <strong>inherited "property and methods"</strong> from the <strong>object</strong>.</p>

        <pre className="code">
            class Student &#123; <br />
                &nbsp; constructor(id, name) &#123; <br />
                    &nbsp;   this.id = id; <br />
                    &nbsp;   this.name = name; <br />
                &nbsp; &#125; <br />
            &#125; <br />
            class FirstYear extends Student &#123; <br />
                &nbsp; constructor(id, name, batch) &#123; <br />
                    &nbsp;   super(id, name); <br />
                    &nbsp;   this.batch = batch; <br />
                &nbsp; &#125; <br />
            &#125; <br />
            const wasek = new FirstYear(36, "Wasek Bellah", 1); <br />
            console.log("ID: " + wasek.id + ", Name: " + wasek.name + " and Batch no: " + wasek.batch);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">ID: 36, Name: Wasek Bellah and Batch no: 1</code></p>


        <h2>Polymorphism</h2>
        <p><strong>Polymorphism</strong> is one of the tenets of <strong>Object-Oriented Programming (OOP)</strong>. The first part of this word has <strong>poly</strong> which means <strong>many</strong>. And <strong>morphism</strong> is a more difficult word which means the <strong>change of form</strong>. But simply to say <strong>Polymorphism</strong> is a <strong>different form of the same thing</strong>. Simply put, <strong>Polymorphism</strong> is to ask to do a job without worrying about how it works.</p>

        <pre className="code">
            class Student &#123; <br />
                &nbsp; constructor(id, name) &#123; <br />
                    &nbsp;   this.id = id; <br />
                    &nbsp;   this.name = name; <br />
                &nbsp; &#125; <br />
                &nbsp; toString() &#123; <br />
                    &nbsp;   return ("ID: " + wasek.id + ", Name: " + this.name); <br />
                &nbsp; &#125; <br />
            &#125; <br />
            class FirstYear extends Student &#123; <br />
                &nbsp; constructor(id, name, batch) &#123; <br />
                    &nbsp;   super(id, name); <br />
                    &nbsp;   this.batch = batch; <br />
                &nbsp; &#125; <br />
                &nbsp; toString() &#123; <br />
                    &nbsp;   return (super.toString() + " and Batch no: " + this.batch); <br />
                &nbsp; &#125; <br />
            &#125; <br />
            const wasek = new FirstYear(36, "Wasek Bellah", 1); <br />
            console.log(wasek.toString());
        </pre>
        <p><strong>Expected output:</strong> <code class="output">ID: 36, Name: Wasek Bellah and Batch no: 1</code></p>


        <h2>Encapsulation</h2>
        <p>The term <strong>encapsulation</strong> can be divided into three parts (<strong>en, capsul, ation</strong>). The middle of the three parts of this word is the <strong>capsule</strong>. What is inside the <strong>capsule</strong> cannot be seen from the outside. Also, The process of wrapping <strong>property and function</strong> within a single unit is known as <strong>Encapsulation</strong>.</p>

        <p>When doing <strong>Object-Oriented Programming (OOP)</strong>, important properties or methods of the <strong>class</strong> are not allowed to be seen from outside. That is, important things are hidden so that others cannot <strong>harm, ruin or change</strong>. Hiding or encapsulating this is called <strong>Encapsulation</strong> in the <strong>Programming language</strong>. This allows you to specify which <strong>users</strong> will be able to view specific parts of your <strong>website</strong> and which <strong>users</strong> will not be able to view.</p>

        <p><em><strong>Encapsulation</strong> has 3 access modifier</em>:</p>
        <ul>
            <li>Public</li>
            <li>Private</li>
            <li>Protected</li>
        </ul>

        <p>If the <strong>method or property of a class</strong> is used <strong>public</strong>, then it can be used from any other <strong>class</strong>.</p>
        <p>If the <strong>method or property of a class</strong> is used <strong>private</strong>, then only this <strong>class</strong> will get access to it.</p>
        <p>If the <strong>method or property of a class</strong> is used <strong>protected</strong>, then the <strong>subclass or the package of this class</strong> will get access.</p>


        <h2>Benefits of Object-Oriented Programming (OOP)</h2>
        <p><strong>Programming</strong> has different ways to approach a problem and design a solution. <strong>Object-Oriented Programming (OOP)</strong> is The paradigm for modern <strong>application development</strong>.</p>

        <p>Suppose you want to change or improve a part of your <strong>software</strong>, now if you have <strong>coded</strong> your software using <strong>Object-Oriented Programming (OOP)</strong>, you can easily change or improve that particular part without touching the other parts. Because <strong>Object-Oriented Programming (OOP)</strong> uses different <strong>classes</strong> for each task, it is easy to work with the part that needs to be worked on. In <strong>Object-Oriented Programming (OOP)</strong>, the <strong>code</strong> will be neatly arranged, so your code will be understood by another <strong>programmer</strong>.</p>

        <p><strong>Object-Oriented Programming (OOP)</strong> has a different style of coding. <strong>Object-Oriented Programming (OOP)</strong> <strong>Code</strong> is <strong>coded</strong> in accordance with the rules and regulations so that one person can easily finish the work another person's unfinished work.</p>


        <h2>Class</h2>
        <p>The main one in <strong>Object-Oriented Programming (OOP)</strong> is its <strong>class</strong>. Everything is defined in this <strong>class</strong>. Each <strong>class</strong> has some features. A <strong>class</strong> has <strong>methods, properties, attributes</strong>. Each <strong>class</strong> has different forms that separate the two <strong>classes</strong> and have their own abilities.</p>

        <p>Different <strong>methods, properties, attributes</strong> are used in the <strong>class</strong> of <strong>Object-Oriented Programming (OOP)</strong>.</p>

        <p>Using the <strong>method</strong> we get a specific task done and the properties help us in different ways.</p>

        <pre className="code">
            class Student &#123; <br />
                &nbsp; constructor(id, name) &#123; <br />
                    &nbsp;   this.id = id; <br />
                    &nbsp;   this.name = name; <br />
                &nbsp; &#125; <br />
                &nbsp; methods() &#123; <br />
                    &nbsp;   &#47;&#47; Define methods <br />
                &nbsp; &#125; <br />
            &#125;
        </pre>


        <h2>Defining methods in a class</h2>
        <p>Whenever a <strong>method</strong> is declared within a <strong>class</strong>, it is defined on the prototype of that <strong>class</strong>. That is, whenever an <strong>object instance</strong> accesses it, it is taken from the prototype of the corresponding <strong>class</strong>.</p>

        <pre className="code">
            class Student &#123; <br />
                &nbsp; constructor(id, name) &#123; <br />
                    &nbsp;   this.id = id; <br />
                    &nbsp;   this.name = name; <br />
                &nbsp; &#125; <br />
                &nbsp; gatId() &#123; <br />
                    &nbsp;   return this.id; <br />
                &nbsp; &#125; <br />
            &#125;
        </pre>


        <h2>Object</h2>
        <p>The <strong>object</strong> is an <strong>instance or blueprint</strong> of the <strong>class</strong>. If we want to use a <strong>method, property or something else</strong> in a <strong>class</strong>, then we have to create an <strong>object</strong> for that <strong>class</strong>. We can use <strong>objects</strong> to perform operations with <strong>methods, properties, attributes</strong> of that <strong>class</strong>.</p>

        <pre className="code">
            class Student &#123; <br />
                &nbsp; constructor(id, name) &#123; <br />
                    &nbsp;   this.id = id; <br />
                    &nbsp;   this.name = name; <br />
                &nbsp; &#125; <br />
                &nbsp; toString() &#123; <br />
                    &nbsp;   return ("ID: " + wasek.id + ", Name: " + this.name); <br />
                &nbsp; &#125; <br />
            &#125; <br />
            const wasek = new Student(36, "Wasek Bellah"); <br />
            console.log(wasek.toString());
        </pre>
        <p><strong>Expected output:</strong> <code class="output">ID: 36, Name: Wasek Bellah</code></p>


        <h2>Constructor Functions</h2>
        <p><strong>Functions</strong> are also <strong>objects in JavaScript</strong>. This is because just like <strong>objects</strong> they have their own <strong>properties and methods</strong>. Functions can be used to construct <strong>objects</strong> as well, and these types of <strong>functions</strong> are known as <strong>constructor functions</strong>.</p>
        <p><strong>Constructor functions</strong> essentially eliminate the need to create individual <strong>object</strong> laterals for similar work. These are useful because you will often come across situations where you do not know how many <strong>objects</strong> you will create. <strong>Constructors</strong> provide means to create as many <strong>objects</strong> as you need in an efficient way.</p>

        <pre className="code">
            function student(id, name) &#123; <br />
                &nbsp; this.id = id; <br />
                &nbsp; this.name = name; <br />
            &#125; <br />
        </pre>
    </>
};
export default JavaScriptObjectOrientedProgramming;